(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-brand-marquee')) {
    customElements.define('gf-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.randomizeStart();
        this.querySelector('button').addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          const button = this.querySelector('button');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
        }, {signal: this.abortController.signal});
      }
      randomizeStart() {
        const track = this.querySelector('.gf-brands__track');
        if (!track) return;
        const duration = parseFloat(getComputedStyle(track).animationDuration) || 120;
        const storageKey = `gf-brand-start:${this.dataset.sectionId || 'brands'}`;
        let previous = NaN;
        try { previous = parseFloat(localStorage.getItem(storageKey)); } catch (e) {}
        let progress = Math.random();
        if (Number.isFinite(previous)) {
          const rawDistance = Math.abs(progress - previous);
          const circularDistance = Math.min(rawDistance, 1 - rawDistance);
          if (circularDistance < 0.12) {
            progress = (previous + 0.31 + Math.random() * 0.38) % 1;
          }
        }
        try { localStorage.setItem(storageKey, String(progress)); } catch (e) {}
        track.style.animationDelay = `-${(duration * progress).toFixed(3)}s`;
      }
      disconnectedCallback() {this.abortController?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-hair-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-hair-slideshow')) {
    customElements.define('gf-hair-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-hair-slide]'));
        this.track = this.querySelector('.gf-hair__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-hair-direction')) this.go(this.current + Number(button.dataset.hairDirection));
          if (button.hasAttribute('data-hair-products')) {
            const list = button.closest('.gf-hair__products').querySelector('.gf-hair__product-list');
            const first = list.querySelector('.gf-hair__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.hairProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.querySelectorAll('.gf-hair__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});

        this.querySelectorAll('.gf-hair__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });

        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-hair__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(this.pickInitialSlide());
      }
      pickInitialSlide() {
        if (!this.slides || this.slides.length <= 1) return 0;
        const storageKey = `gf-initial-slide:${this.dataset.sectionId || this.tagName.toLowerCase()}`;
        let previous = -1;
        try {
          const saved = Number(localStorage.getItem(storageKey));
          if (Number.isInteger(saved) && saved >= 0 && saved < this.slides.length) previous = saved;
        } catch (e) {}
        let next = Math.floor(Math.random() * this.slides.length);
        if (next === previous) {
          const jump = 1 + Math.floor(Math.random() * (this.slides.length - 1));
          next = (previous + jump) % this.slides.length;
        }
        try { localStorage.setItem(storageKey, String(next)); } catch (e) {}
        return next;
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-hair__hero-image');
        if (image) image.loading='eager';
      }
      go(index) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-hair-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
      }
      updateRail(list) {
        const controls=list.closest('.gf-hair__products');
        const prev=controls?.querySelector('[data-hair-products="-1"]');
        const next=controls?.querySelector('[data-hair-products="1"]');
        if (prev) prev.disabled=list.scrollLeft<2;
        if (next) next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-mamy-baby-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-mamy-slideshow')) {
    customElements.define('gf-mamy-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-mamy-slide]'));
        this.track = this.querySelector('.gf-mamy__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-mamy-direction')) this.go(this.current + Number(button.dataset.mamyDirection));
          if (button.hasAttribute('data-mamy-products')) {
            const list = button.closest('.gf-mamy__products').querySelector('.gf-mamy__product-list');
            const first = list.querySelector('.gf-mamy__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.mamyProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.querySelectorAll('.gf-mamy__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});

        this.querySelectorAll('.gf-mamy__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });

        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-mamy__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(this.pickInitialSlide());
      }
      pickInitialSlide() {
        if (!this.slides || this.slides.length <= 1) return 0;
        const storageKey = `gf-initial-slide:${this.dataset.sectionId || this.tagName.toLowerCase()}`;
        let previous = -1;
        try {
          const saved = Number(localStorage.getItem(storageKey));
          if (Number.isInteger(saved) && saved >= 0 && saved < this.slides.length) previous = saved;
        } catch (e) {}
        let next = Math.floor(Math.random() * this.slides.length);
        if (next === previous) {
          const jump = 1 + Math.floor(Math.random() * (this.slides.length - 1));
          next = (previous + jump) % this.slides.length;
        }
        try { localStorage.setItem(storageKey, String(next)); } catch (e) {}
        return next;
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-mamy__hero-image');
        if (image) image.loading='eager';
      }
      go(index) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-mamy-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
      }
      updateRail(list) {
        const controls=list.closest('.gf-mamy__products');
        const prev=controls?.querySelector('[data-mamy-products="-1"]');
        const next=controls?.querySelector('[data-mamy-products="1"]');
        if (prev) prev.disabled=list.scrollLeft<2;
        if (next) next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-men-body-oral-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-mbo-slideshow')) {
    customElements.define('gf-mbo-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-mbo-slide]'));
        this.track = this.querySelector('.gf-mbo__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-mbo-direction')) this.go(this.current + Number(button.dataset.mboDirection));
          if (button.hasAttribute('data-mbo-products')) {
            const list = button.closest('.gf-mbo__products').querySelector('.gf-mbo__product-list');
            const first = list.querySelector('.gf-mbo__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.mboProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.querySelectorAll('.gf-mbo__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});

        this.querySelectorAll('.gf-mbo__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });

        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-mbo__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(this.pickInitialSlide());
      }
      pickInitialSlide() {
        if (!this.slides || this.slides.length <= 1) return 0;
        const storageKey = `gf-initial-slide:${this.dataset.sectionId || this.tagName.toLowerCase()}`;
        let previous = -1;
        try {
          const saved = Number(localStorage.getItem(storageKey));
          if (Number.isInteger(saved) && saved >= 0 && saved < this.slides.length) previous = saved;
        } catch (e) {}
        let next = Math.floor(Math.random() * this.slides.length);
        if (next === previous) {
          const jump = 1 + Math.floor(Math.random() * (this.slides.length - 1));
          next = (previous + jump) % this.slides.length;
        }
        try { localStorage.setItem(storageKey, String(next)); } catch (e) {}
        return next;
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-mbo__hero-image');
        if (image) image.loading='eager';
      }
      go(index) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-mbo-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
      }
      updateRail(list) {
        const controls=list.closest('.gf-mbo__products');
        const prev=controls?.querySelector('[data-mbo-products="-1"]');
        const next=controls?.querySelector('[data-mbo-products="1"]');
        if (prev) prev.disabled=list.scrollLeft<2;
        if (next) next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-skincare-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-care-slideshow')) {
    customElements.define('gf-care-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-care-slide]'));
        this.track = this.querySelector('.gf-care__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-care-direction')) this.go(this.current + Number(button.dataset.careDirection));
          if (button.hasAttribute('data-care-products')) {
            const list = button.closest('.gf-care__products').querySelector('.gf-care__product-list');
            const first = list.querySelector('.gf-care__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.careProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.querySelectorAll('.gf-care__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});

        this.querySelectorAll('.gf-care__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {
            touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
          }, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });

        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-care__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(this.pickInitialSlide());
      }
      pickInitialSlide() {
        if (!this.slides || this.slides.length <= 1) return 0;
        const storageKey = `gf-initial-slide:${this.dataset.sectionId || this.tagName.toLowerCase()}`;
        let previous = -1;
        try {
          const saved = Number(localStorage.getItem(storageKey));
          if (Number.isInteger(saved) && saved >= 0 && saved < this.slides.length) previous = saved;
        } catch (e) {}
        let next = Math.floor(Math.random() * this.slides.length);
        if (next === previous) {
          const jump = 1 + Math.floor(Math.random() * (this.slides.length - 1));
          next = (previous + jump) % this.slides.length;
        }
        try { localStorage.setItem(storageKey, String(next)); } catch (e) {}
        return next;
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-care__hero-image');
        if (image) image.loading='eager';
      }
      go(index) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-care-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
      }
      updateRail(list) {
        const controls=list.closest('.gf-care__products');
        const prev=controls?.querySelector('[data-care-products="-1"]');
        const next=controls?.querySelector('[data-care-products="1"]');
        if (prev) prev.disabled=list.scrollLeft<2;
        if (next) next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-supplements-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-supp-slideshow')) {
    customElements.define('gf-supp-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-supp-slide]'));
        this.track = this.querySelector('.gf-supp__track');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-supp-direction')) this.go(this.current + Number(button.dataset.suppDirection));
          if (button.hasAttribute('data-supp-products')) {
            const list = button.closest('.gf-supp__products').querySelector('.gf-supp__product-list');
            const first = list.querySelector('.gf-supp__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.suppProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});

        this.querySelectorAll('.gf-supp__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});

        this.querySelectorAll('.gf-supp__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;}, {passive:true, signal});
        });

        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-supp__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.go(this.pickInitialSlide());
      }
      pickInitialSlide() {
        if (!this.slides || this.slides.length <= 1) return 0;
        const storageKey = `gf-initial-slide:${this.dataset.sectionId || this.tagName.toLowerCase()}`;
        let previous = -1;
        try {
          const saved = Number(localStorage.getItem(storageKey));
          if (Number.isInteger(saved) && saved >= 0 && saved < this.slides.length) previous = saved;
        } catch (e) {}
        let next = Math.floor(Math.random() * this.slides.length);
        if (next === previous) {
          const jump = 1 + Math.floor(Math.random() * (this.slides.length - 1));
          next = (previous + jump) % this.slides.length;
        }
        try { localStorage.setItem(storageKey, String(next)); } catch (e) {}
        return next;
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-supp__hero-image');
        if (image) image.loading='eager';
      }
      go(index) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-supp-status]');
        if (status) {
          status.setAttribute('aria-live','polite');
          status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        }
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
      }
      updateRail(list) {
        const controls=list.closest('.gf-supp__products');
        const prev=controls?.querySelector('[data-supp-products="-1"]');
        const next=controls?.querySelector('[data-supp-products="1"]');
        if (prev) prev.disabled=list.scrollLeft<2;
        if (next) next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-three-slides-copy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-care-slideshow')) {
    customElements.define('gf-care-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.current = 0;
        this.slides = Array.from(this.querySelectorAll('[data-care-slide]'));
        this.track = this.querySelector('.gf-care__track');
        this.interval = Math.min(7000, Math.max(5000, Number(this.dataset.interval) || 6000));
        this.visible = false;
        this.hovered = this.matches(':hover');
        this.focused = this.contains(document.activeElement);
        this.editor = Boolean(window.Shopify?.designMode);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-care-direction')) this.go(this.current + Number(button.dataset.careDirection));
          if (button.hasAttribute('data-care-products')) {
            const list = button.closest('.gf-care__products').querySelector('.gf-care__product-list');
            const first = list.querySelector('.gf-care__product');
            if (!first) return;
            const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(list).gap);
            const visible = Math.max(1, Math.round(list.clientWidth / step));
            list.scrollBy({left: Number(button.dataset.careProducts) * step * visible, behavior: this.motion.matches ? 'auto' : 'smooth'});
          }
        }, {signal});
        this.addEventListener('pointerenter', event => {if (event.pointerType === 'mouse') {this.hovered=true;this.schedule();}}, {signal});
        this.addEventListener('pointerleave', event => {if (event.pointerType === 'mouse') {this.hovered=false;this.schedule();}}, {signal});
        this.addEventListener('focusin', () => {this.focused=true;this.schedule();}, {signal});
        this.addEventListener('focusout', () => {queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});}, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.motion.addEventListener('change', () => this.schedule(), {signal});
        this.querySelectorAll('.gf-care__product-list').forEach(list => {
          list.addEventListener('scroll', () => this.updateRail(list), {passive:true, signal});
          this.updateRail(list);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index);
        }, {signal});
        this.querySelectorAll('.gf-care__hero').forEach(hero => {
          let touchStart;
          hero.addEventListener('touchstart', event => {touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};this.touching=true;this.schedule();}, {passive:true, signal});
          hero.addEventListener('touchend', event => {
            if (touchStart) {
              const dx=event.changedTouches[0].clientX-touchStart.x;
              const dy=event.changedTouches[0].clientY-touchStart.y;
              if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.go(this.current+(dx<0?1:-1));
            }
            touchStart=null;this.touching=false;this.schedule();
          }, {passive:true, signal});
          hero.addEventListener('touchcancel', () => {touchStart=null;this.touching=false;this.schedule();}, {passive:true, signal});
        });
        this.resizeObserver = new ResizeObserver(() => this.querySelectorAll('.gf-care__product-list').forEach(list=>this.updateRail(list)));
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:0});
        this.intersectionObserver.observe(this);
        this.preloadNext();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.hovered || this.focused || this.touching || !this.visible || document.hidden || this.motion.matches || this.editor) return;
        this.timer=setTimeout(()=>this.go(this.current+1, true),this.interval);
      }
      preloadNext() {
        if (!this.slides.length) return;
        const image=this.slides[(this.current+1)%this.slides.length].querySelector('.gf-care__hero-image');
        if (image) image.loading='eager';
      }
      go(index, automatic=false) {
        if (!this.slides.length) return;
        this.current=(index+this.slides.length)%this.slides.length;
        this.track.style.transform=`translateX(-${this.current*100}%)`;
        this.slides.forEach((slide,i)=>{slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
        const status=this.querySelector('[data-care-status]');
        status.setAttribute('aria-live',automatic?'off':'polite');
        status.textContent=`${this.slides[this.current].getAttribute('aria-label')} ${this.current+1} / ${this.slides.length}`;
        this.slides[this.current].querySelectorAll('img[loading="lazy"]').forEach(img=>{img.loading='eager';});
        this.preloadNext();
        this.schedule();
      }
      updateRail(list) {
        const controls=list.closest('.gf-care__products');
        controls.querySelector('[data-care-products="-1"]').disabled=list.scrollLeft<2;
        controls.querySelector('[data-care-products="1"]').disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.initialized=false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
